import * as ngCore from '@angular/core'
import * as store from '@attain-apps/fe/web/main/lib/store'

import type * as variableOverrides from '../../../../../variable-overrides'
import type * as aliases from '../../../../aliases'
import * as dynamicEcs from '../../../../dynamic-ecs'
import type * as currentRendering from '../../feature'
import type * as actions from '../actions'

import { getActionsConfig } from './actions'
import { ApiService } from './api.service'
import * as effects from './effects'
import * as extraReducers from './extra-reducers'
import { Selectors } from './selectors'
import { State } from './state'

export class Feature extends store.Feature<
  State,
  Selectors,
  ReturnType<typeof getActionsConfig>
> {
  /** @see {@link ApiService} */
  public readonly api = ngCore.inject(ApiService)

  constructor(
    currentRenderingFeature: currentRendering.Feature,
    actionsFeature: actions.Feature,
    variablesFeature: variableOverrides.Feature,
    aliasesFeature: aliases.Feature,
  ) {
    super({
      actions: getActionsConfig(),
      initialState: State.INITIAL,
      name: 'Widgets',
      parent: currentRenderingFeature,
      selectors: () => new Selectors(this, currentRenderingFeature),
    })

    const dynamicEcsFeature = ngCore.inject(dynamicEcs.Feature)

    this.registerEffects(
      effects.getRenderOnRequest(),
      effects.reRenderWatchedWidgets(
        currentRenderingFeature,
        actionsFeature,
        variablesFeature,
        aliasesFeature,
      ),
      effects.triggerWidgetsRenderings(
        currentRenderingFeature,
        variablesFeature,
        aliasesFeature,
      ),
      effects.putWidgetVariableDefinitions(variablesFeature),
      effects.putWidgetAlias(aliasesFeature),
      effects.triggerEcBootstrap(
        currentRenderingFeature,
        actionsFeature,
        dynamicEcsFeature,
      ),
      effects.triggerEcDisposeOnPageRenderRequest(
        currentRenderingFeature,
        dynamicEcsFeature,
      ),
      effects.triggerEcDisposeOnWidgetRenderRequest(dynamicEcsFeature),
    )

    this.registerExtraReducers(
      // TODO: usually not the best idea, but to avoid flickering, this
      // is the best thing we can do right now
      extraReducers.resetOnPageRender(currentRenderingFeature),
    )
  }
}
